module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-191.60f51591.svg";